(function () {
    'use strict';

    angular.module('app').directive('fodbzCivilStatuses', CivilStatusesDirective);

    CivilStatusesDirective.$inject = ['$compile', '$rootScope'];

    function CivilStatusesDirective($compile, $rootScope) {
        const template = `<div>
                            <div class="row" ng-if="fodbzModel.length===9999">
                                <ng-form name="CivilStateForm">
                                    <div class="col-lg-3 col-md-3 col-sm-4 col-xs-12">
                                        <fodbz-label-required
                                            fodbz-field="{{fodbzFieldConst}}"
                                            fodbz-resource="{{fodbzResource}}">
                                        </fodbz-label-required>
                                    </div>
                                    <div class="col-lg-3 col-md-3 col-sm-8 col-xs-12">
                                        <fodbz-dropdown-required
                                                fodbz-model="fodbzModel[0].StatusCode"
                                                fodbz-field-const="{{fodbzFieldConst}}"
                                                organisation-types="fodbzList"
                                                fodbz-init="{{fodbzInit}}">
                                        </fodbz-dropdown-required >
                                        <fodbz-validation fodbz-errors="CivilStateForm[fodbzFieldConst].$error" fodbz-role="Alert" />
                                    </div>
                                    <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12" style="margin-right:10px;">
                                        <button
                                            class="btn pull-right" 
                                            ng-click="Add()">
                                            <i class="fa fa-plus"></i> {{fodbzResourceAdd}}
                                        </button>
                                    </div>
                                </ng-form>
                            </div>
                            <div class="row" ng-if="fodbzModel.length>0">
                                <div class="col-lg-3 col-md-3 col-sm-4 col-xs-12">
                                    <fodbz-label-required
                                            fodbz-field="MyCivilState_Label"
                                            fodbz-resource="{{fodbzResource}}">
                                    </fodbz-label-required>
                                </div>
                                <div class="col-lg-3 col-md-3 col-sm-4 col-xs-12" ng-if="fodbzModel[0].StatusCode>10" >
                                    <fodbz-label-required
                                            fodbz-field="MyCivilState_DateFrom_Label"
                                            fodbz-resource="{{fodbzResourceFrom}}">
                                    </fodbz-label-required>
                                </div>
                            </div>
                            <div class="row" ng-if="fodbzModel.length>0" ng-repeat="CivilState in fodbzModel track by $index">
                                <ng-form name="CivilStateForm" ng-if="!CivilState.FromRR">
                                    <div class="col-lg-3 col-md-3 col-sm-8 col-xs-12">
                                        <fodbz-dropdown-required 
                                                fodbz-model="CivilState.StatusCode"
                                                fodbz-field-const="MyCivilState{{$index}}"
                                                organisation-types="fodbzList"
                                                fodbz-init="{{fodbzInit}}">
                                        </fodbz-dropdown-required>
                                        <fodbz-validation fodbz-errors="CivilStateForm['MyCivilState' + $index].$error" fodbz-role="Alert" />
                                    </div>
                                    <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12" ng-if="CivilState.StatusCode>10">
                                        <fodbz-datepicker
                                                fodbz-field-const="MyCivilState_DateFrom{{$index}}"
                                                fodbz-object="CivilState.From"
                                                fodbz-orientation="bottom"
                                                fodbz-language-code="{{fodbzLanguageCode}}"
                                                fodbz-place-holder="{{fodbzPlaceHolder}}">
                                        </fodbz-datepicker>
                                        <fodbz-validation fodbz-errors="CivilStateForm['MyCivilState_DateFrom' + $index].$error" fodbz-role="Alert" />
                                    </div>
                                    <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                                        <button
                                            class="btn pull-right" style="margin-right:10px;"
                                            ng-click="Add()">
                                            <i class="fa fa-plus"></i> {{fodbzResourceAdd}}
                                        </button>
                                        <button ng-if="fodbzModel.length>0" 
                                            class="btn btn-danger pull-right" style="margin-right:10px;" 
                                            ng-click="Remove(CivilState)">
                                            <i class="fa fa-trash"></i>
                                        </button>
                                    </div>
                                 </ng-form>
                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" ng-if="CivilState.FromRR && CivilState.StatusCode && CivilState.From && CivilState.Until">
                                    <p class="col-lg-3 col-md-3 col-sm-12 col-xs-12">{{ (fodbzList | filter:{Key: CivilState.StatusCode }:true | limitTo:1)[0].Value }}</p>
                                    <p class="col-lg-3 col-md-3 col-sm-6 col-xs-6">{{CivilState.From | date:'dd/MM/yyyy'}}</p>
                                    <p class="col-lg-3 col-md-3 col-sm-6 col-xs-6">{{CivilState.Until | date:'dd/MM/yyyy'}}</p>
                                    <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                                        <button
                                            class="btn pull-right" style="margin-right:10px;"
                                            ng-click="Add()">
                                            <i class="fa fa-plus"></i> {{fodbzResourceAdd}}
                                        </button>
                                        <button ng-if="fodbzModel.length>0" 
                                            class="btn btn-danger pull-right" style="margin-right:10px;" 
                                            ng-click="Remove(CivilState)">
                                            <i class="fa fa-trash"></i>
                                        </button>
                                    </div>
                                </div>
                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" ng-if="CivilState.FromRR && CivilState.StatusCode && !CivilState.Until">
                                    <p class="col-lg-3 col-md-3 col-sm-6 col-xs-12">{{ (fodbzList | filter:{Key: CivilState.StatusCode }:true | limitTo:1)[0].Value }}</p>
                                    <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12" ng-if="CivilState.StatusCode>10">
                                        <fodbz-datepicker
                                                fodbz-field-const="MyCivilState_DateFrom{{$index}}"
                                                fodbz-object="CivilState.From"
                                                fodbz-orientation="bottom"
                                                fodbz-language-code="{{fodbzLanguageCode}}"
                                                fodbz-place-holder="{{fodbzPlaceHolder}}">
                                        </fodbz-datepicker>
                                        <fodbz-validation fodbz-errors="CivilStateForm['MyCivilState_DateFrom' + $index].$error" fodbz-role="Alert" />
                                    </div>

                                    <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                                        <button
                                            class="btn pull-right" style="margin-right:10px;"
                                            ng-click="Add()" >
                                            <i class="fa fa-plus"></i> {{fodbzResourceAdd}}
                                        </button>
                                        <button ng-if="fodbzModel.length>0" 
                                            class="btn btn-danger pull-right" style="margin-right:10px;" 
                                            ng-click="Remove(CivilState)">
                                            <i class="fa fa-trash"></i>
                                        </button>
                                    </div>
                                </div>
                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" ng-if="CivilState.FromRR && CivilState.StatusCode && !CivilState.From && !CivilState.Until">
                                    <p class="col-lg-2 col-md-3 col-sm-6 col-xs-12">{{ (fodbzList | filter:{Key: CivilState.StatusCode }:true | limitTo:1)[0].Value }}</p>
                                    <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                                        <button
                                            class="btn pull-right" style="margin-right:10px;"
                                            ng-click="Add()" >
                                            <i class="fa fa-plus"></i> {{fodbzResourceAdd}}
                                        </button>
                                        <button ng-if="fodbzModel.length>0" 
                                            class="btn btn-danger pull-right" style="margin-right:10px;" 
                                            ng-click="Remove(CivilState)">
                                            <i class="fa fa-trash"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>`;
        return {
            transclude: true,
            // eslint-disable-next-line angular/no-directive-replace
            replace: true,
            scope: {
                fodbzModel: '=',
                fodbzFieldConst: '@',
                fodbzInfoTitle: '@',
                fodbzInfo: '@',
                fodbzInfoFrom: '@',
                fodbzInfoTo: '@',
                fodbzList: '=',
                fodbzResource: '@',
                fodbzResourceFrom: '@',
                fodbzResourceTo: '@',
                fodbzResourceAdd: '@',
                fodbzResourceRemove: '@',
                fodbzErrorItem: '=',
                fodbzLanguageCode: '@',
                fodbzPlaceHolder: '@',
                fodbzInit: '@'
            },
            controller: ['$scope', function ($scope) {
                $scope.fodbzInfoTitle = angular.isDefined($scope.fodbzInfoTitle) ? $scope.fodbzInfoTitle : 'InfoSelf';
                $scope.Placing = $scope.fodbzFieldConst;
            }],
            link: function (scope, elem) {
                scope.fodbzInfoTitle = angular.isDefined(scope.fodbzInfoTitle) ? scope.fodbzInfoTitle : 'InfoSelf';
                scope.Add = function () {
                    scope.fodbzModel.push({ PublicId: $rootScope.guid.new() });
                };
                scope.Remove = function (item) {
                    const index = scope.fodbzModel.indexOf(item);
                    scope.fodbzModel.splice(index, 1);

                    if (scope.fodbzModel.length === 0) {
                        scope.Add();
                    }
                };
                scope.$watch('fodbzModel', function (newVal) {
                    newVal.forEach(function (item) {
                        if (item.StatusCode === "10") item.From = null;
                    });
                }, true);

                const linkFn = $compile(template.replace(/MyCivilState/g, scope.Placing));
                const content = linkFn(scope);
                elem.append(content);
            }
        };
    }
})();